<template>
      <div class="roleCreate">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'role', params: {} }">
          Role
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'roleCreate', params: {} }">
            Create Role
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Create Role</v-card-title>
          <v-card-text>
            <role-form></role-form>
          </v-card-text>
        </v-card>
      </div>
    </template>
    <script>
    import RoleForm from './RoleForm.vue';

    export default {
      name: 'role',
      components: {
        RoleForm
      },
      created() {
        this.$emit("showParent", false);
      }
    }
    </script>
    